import { useEffect, useState } from "react";
import { ArrowDownCircle, ArrowUpCircle } from "lucide-react";
import { api } from "../../lib/api";

const money = (n) => `$${Number(n || 0).toLocaleString()}`;

export default function CashflowBlock() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/hub/cashflow").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;

  const Col = ({ title, icon: Icon, items, total, tone }) => (
    <div className="bg-white border border-navy/10 rounded-lg p-5" data-testid={`cashflow-${tone}`}>
      <div className="flex items-center justify-between mb-3">
        <div className={`flex items-center gap-2 text-sm font-medium ${tone === "in" ? "text-emerald-600" : "text-rose-600"}`}>
          <Icon className="w-4 h-4" /> {title}
        </div>
        <div className="text-lg font-medium">{money(total)}</div>
      </div>
      {items.length === 0 ? <p className="text-xs text-navy/35 py-3">Nada pendiente.</p> : (
        <div className="space-y-1.5 max-h-52 overflow-y-auto thin-scroll">
          {items.map((it) => (
            <div key={it.id} className="flex items-center gap-2 text-sm">
              <span className="flex-1 min-w-0 truncate">{it.concept}{it.project ? <span className="text-navy/40"> · {it.project}</span> : ""}</span>
              <span className="font-medium shrink-0">{money(it.amount)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <div className="grid md:grid-cols-2 gap-4" data-testid="hub-cashflow">
      <Col title="Por cobrar" icon={ArrowDownCircle} items={d.receivables} total={d.receivable_total} tone="in" />
      <Col title="Por pagar" icon={ArrowUpCircle} items={d.payables} total={d.payable_total} tone="out" />
    </div>
  );
}
